import { createQueryClient } from './query-client.js';

/**
 * Синглтон. Нужен именно модульный, а не созданный в компоненте: бутстрап сессии
 * (lib/auth/user-session.ts) наполняет кэш ДО первого рендера, и клиент, созданный
 * внутри дерева React, к тому моменту ещё не существовал бы.
 */
export const queryClient = createQueryClient();
